<template>
  <div id="app">
   
 <!-- <index/>
 <Navigation/> -->
 
 <router-view />
  </div>
</template>

<script>
//import Index from './components/IndexPage.vue'
//import Navigation from './components/NavigationPage.vue'

export default {
  name: 'App',
  components: {
 // Index,Navigation
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
